import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { useLanguageHandler } from '@/hooks/useLanguageHandler';
import { captureAuthorizeQuery } from '@/lib/oauth/oauth-flow';

const OAuthLayout = () => {
	useLanguageHandler();
	return <Outlet />;
};

export const Route = createFileRoute('/_oauth')({
	beforeLoad: ({ context, location }) => {
		const continuation = captureAuthorizeQuery({ search: location.searchStr });
		if (context.globalStore.getState().authenticated) return;
		if (continuation.kind === 'valid') throw redirect({ href: `/login?${continuation.query}` });
		throw redirect({ to: '/login' });
	},
	component: OAuthLayout,
});
